/// <summary>
/// This object provides js functions for device attribute assignment <br/>
/// <br/>
/// Author: AFU<br />
/// Date: 12.3.2025<br />
/// Copyright ©: EUDT GmbH 2025 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 12.3.2025                                             *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.Devices", jQuery.common.vcBaseV4, {
    
    _create: function () {
   
        this._createVisual(384);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
           
            me._setRoot(".dm-device-attr");
          
            me._buildHtml();
            //me._setHeightsAndWidths();
        } catch (e) { me._writeErr(e); return false;}
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            me._initStructure();
            me._fetch();
        } catch (e) { me._writeErr(e);return false; }
        return true;
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        var me = this;
        try {
            me.myHtml = {
                menu: {}, list: {} };
            //top menu for save button
            let obj = me.myHtml.menu;
            obj.wrapper = me._setObj("", "vc-grid-margin-bottom").css("width", "100%").css("height", "30px");
            obj.save = me._setObj("btn-save", "").css("float", "right").html(me.specific.resources.save);
            obj.wrapper.append(obj.save);

            obj = me.myHtml.list;
            obj.wrapper = me._setObj("", "vc-list");
            obj.header = me._setListHeader("");
            // generate header list
            var line = me._setListItem();
            line.column.append(me._setListElement("", "w15").html(me.specific.resources.type));
            line.column.append(me._setListElement("", "w15").html(me.specific.resources.name));
            line.column.append(me._setListElement("", "w15").html(me.specific.resources.identifier));
            line.column.append(me._setListElement("", "w50").html(me.specific.resources.values));
            obj.header.append(line.item);

            obj.entries = me._setObj("entries", "vc-list-table").css("max-height", "none");
            obj.wrapper.append(obj.header, obj.entries);

            me.myRoot.append(me.myHtml.menu.wrapper, me.myHtml.list.wrapper);
        

        } catch (e) {me._writeErr(e);return false;}
        return true;
    },

    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {
            //save button click handler
            me.myHtml.menu.save.off("click").on("click", function () { me._save();}).button().button("disable");

            me.myHtml.list.entries.off("keyup", ".validate").on("keyup", ".validate", function () { me._validate();  });
          
        } catch (e) { me._writeErr(e); }
    },

    _validate: function () {
        /// <summary>
        /// This function iterates all entries which should be validated and validates the current values 
        /// </summary>
        var me = this;
        try {
            
            $.each(me.myHtml.list.entries.find(".validate"), function() {
                let obj = $(this);
                obj.removeClass("invalid");
                let val = trimAll(obj.val() + "");
                var entry = obj.data("entry");
                switch (entry.DataTypeName) {
                    case "string":
                        if (val.length < entry.DataMin || val.length > entry.DataMax) { obj.addClass("invalid"); }
                        break;
                    case "int":
                        if (!validateNotEmpty(val) || !validateInteger(val)) { obj.addClass("invalid"); }
                        break;
                    case "double":
                        if (!validateNotEmpty(val) || !validateNumeric(val) ||   isNaN(parseFloat(val))) {obj.addClass("invalid");}
                        break;
                }
            });

            var bValid = true;
            //find any invalid fields
            if (me.myHtml.list.entries.find(".invalid").length > 0) { bValid = false; }
            if (me.myHtml.list.entries.find(".error").length > 0) { bValid = false; }

            me.myHtml.menu.save.button(bValid ? "enable" : "disable");


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _fetch: function () {
        /// <summary>
        /// This function fetches the data based on the current settings
        /// </summary>
        var me = this;
        try {
            me._setLoadingIcon(me.myHtml.list.entries);
            me.getData({ TypeId: 1 }, function (result) {
                
                //check response content
                if (result == null) { me.showMessage(me.resources.err_loadData, true); return true; }
                me.myData = result;
                me._generateList();
                me._validate(); 
            });
        } catch (e) { me._writeErr(e); return false; }return true;
    },

    _generateList: function () {
        /// <summary>
        /// This function generates the table and fills the list with data
        /// </summary>
        var me = this;
        try {
           
            if (me.myData.length == 0) {
                me.myHtml.list.entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }
            //clear list
            me.myHtml.list.entries.html("");
            // fill entry list
            for (i = 0; i < me.myData.length; i++) { me._fillRow(me.myData[i]); };
            //we use no filter - so we set everything to found
            me.myHtml.list.entries.find(".vc-list-item").addClass("found");
            me._setAltListStyle(me.myHtml.list.entries);
            return true;

        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },

    _fillRow: function (row) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
            var input, description;
            var line = me._setListItem();

            line.column.append(me._setListElement("", "w15").html(row.ContextTypeId == 1 ? me.specific.resources.deviceType : me.specific.resources.hardwareProtocol));
            var name = row.Name + " " + row.Id + "  " + row.AssignedId;
            if (row.Description.length > 0) { name += "<br/><span style='font-size:smaller'>" + row.Description + "</span>"; }
            line.column.append(me._setListElement("", "w15").html(name));
            line.column.append(me._setListElement("", "w15").html(row.Identifier + "<br/>"));

            switch (row.DataTypeName) {
                case "string":
                    input = $("<input>", { class: "data string txtEnabled validate" }).data("entry", row);
                    input.val(row.AssignedId > 0 ? row.AssignedValue : row.DefaultValue );
                    description = row.DataMin + "-" + row.DataMax + " " + me.specific.resources.characters;
                    break;
                case "int":
                    input = $("<input>", { class: "data int txtEnabled validate" }).data("entry", row);
                    input.val(row.AssignedId > 0 ? row.AssignedValue : row.DefaultValue);
                    description = me.specific.resources.integer + ": " + row.DataMin + "/" + row.DataMax;
                    break;
                case "double":
                    input = $("<input>", { class: "data double txtEnabled validate" }).data("entry", row);
                    input.val(row.AssignedId > 0 ? row.AssignedValue : row.DefaultValue);
                    description = me.specific.resources.decimal + ": " + row.DataMin + "/" + row.DataMax;
                    break;
                case "bool":
                    input = $("<input>", { type: 'checkbox', class: "data" }).data("entry", row);
                    var val = row.AssignedId > 0 ? row.AssignedValue : row.DefaultValue;
                    if (val == "true") input.prop("checked", "checked");
                    description = "";
                    break;
                case "dropdown":
                    var bValid = true;
                    if (row.DataSource.length == 0) {
                        input = $("<div>").addClass("error").html(me.specific.resources.noDataSource);
                        bValid = false;
                    } 
                    var vals = row.DataSource.split(";");
                    var currentValue = parseInt(row.AssignedId > 0 ? row.AssignedValue : row.DefaultValue);
                    //if no value was set - use the first indext
                    if (isNaN(currentValue)) currentValue = 0;

                    if (vals.length < currentValue) {
                        input = $("<div>").addClass("error").html(me.specific.resources.wrongDataSourceStructure);
                        bValid = false;
                    } 

                    if (bValid) {
                        input = $("<select>", { class: "data ddlEnabled" }).data("entry", row);
                        var index = 0;
                        for (var val of vals) {
                            input.append($("<option>").prop('value', index).text(val));
                            index++;
                        }
                        input.val(currentValue);
                    }
                    description = "";
                    break;
                default:
            }

            //add an info if the value is still the default value
            description += row.AssignedId == -1 ? ' (' + me.specific.resources.defaultValue + ')' : '';

            line.column.append(me._setListElement("", "w50").html(input).append("<br/><span style='font-size:smaller'>" + description + "</span>"));
            me.myHtml.list.entries.append(line.item);

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _save: function () {
        /// <summary>
        /// This function saves the data based on the current settings
        /// </summary>
        var me = this;
        try {
            me._validate();
            if (me.myHtml.menu.save.hasClass("ui-state-disabled")) return true;
            var param = { TypeId: 1, Entries: [] }

            $.each(me.myHtml.list.entries.find(".data"), function () {
                let obj = $(this);
                var entry = obj.data("entry");
                switch (entry.DataTypeName) {
                    case "string":
                        entry.NewValue = trimAll(obj.val() + "");
                        break;
                    case "int":
                        entry.NewValue = trimAll(obj.val() + "");
                        break;
                    case "double":
                        entry.NewValue = trimAll(obj.val() + "");
                        break;
                    case "bool":
                        entry.NewValue = (obj.prop("checked") + "").toLowerCase();
                        break;
                    case "dropdown":
                        entry.NewValue = obj.val();
                        break;
                    default:
                }
                param.Entries.push(entry);

            });

            me.updateData(param, function (result) {
                me.myHtml.menu.save.button("disable");
                //check response content
                if (result == false) {me.showMessage(me.resources.err_saveData, true);return true;}
                me._fetch();
            });


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            let hList = me._getVisualHeight() - me.myHtml.menu.wrapper.outerHeight()-20;

            me.myHtml.list.wrapper.css("height", hList);
            hList -= me.myHtml.list.header.outerHeight();
            me.myHtml.list.entries.css("max-height", hList);


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    specificInfoHandling: function (bError) {
        /// <summary>
        /// This function handles error states - it hides specific objects on error message
        /// </summary>
        var me = this;
        try {
            if (bError) {
                me.myHtml.menu.wrapper.hide();
                me.myHtml.list.wrapper.hide();
            }
           
        } catch (e) { me._writeErr(e); return false;}
        return true;
    }
});